import cn from 'classnames';

import { Seller, useCheckoutContext } from '@zooplus/checkout-state';
import { FlatBox, H3, P2, P1 } from '@zooplus/ui-components';

import { useTranslation } from '@hooks/use-translations';
import { CHECKOUT_STATE_PROJECT_ID } from '@utilities/constants';

import styles from './cart-shipment-header.module.scss';

export type CartShipmentHeaderProps = {
  seller: Seller;
  index: number;
  totalShipments: number;
  shippingCost?: number;
  shipmentTotal: number;
};

const CartShipmentHeader = ({
  seller,
  index,
  totalShipments,
  shippingCost,
  shipmentTotal,
}: CartShipmentHeaderProps) => {
  const { t } = useTranslation();
  const { checkoutState } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);

  return (
    <FlatBox
      className={styles.shipmentHeaderContainer}
      data-testid="cart-shipment-header"
      variant="grey"
      rounded>
      <div>
        <H3 className={styles.noMargin} data-testid="cart-shipment-header-delivery">
          {totalShipments === 1 && t('checkout.preview.yourProducts')}
          {totalShipments > 1 &&
            t('cart.marketplace.delivery.label', {
              0: `${index + 1}/${totalShipments}`,
              interpolation: { escapeValue: false },
            })}
        </H3>
        <P2 className={styles.noMargin} data-testid="cart-shipment-header-seller">
          {t('cart.marketplace.soldBy.1P.label', { 0: seller.name })}
        </P2>
      </div>
      {totalShipments > 1 && (
        <div className={styles.shipmentHeaderRight}>
          <div className={styles.shipmentInfo}>
            <P2 className={styles.noMargin} data-testid="cart-shipment-header-delivery-fee-title">
              {t('cart.marketplace.deliveryFee.label')}
            </P2>
            <P1
              className={cn(styles.noMargin, styles.uppercase)}
              bold
              data-testid="cart-shipment-header-delivery-fee">
              {shippingCost
                ? t('cart.marketplace.currency.value', {
                    val: shippingCost,
                    formatParams: {
                      val: { currency: checkoutState?.cart?.currency },
                    },
                  })
                : t('cart.summary.shippingFees.freeShipping')}
            </P1>
          </div>
          <div>
            <P2 className={styles.noMargin} data-testid="cart-shipment-header-order-summary-title">
              {t('cart.marketplace.orderSummary.label')}
            </P2>
            <P1 className={styles.noMargin} bold data-testid="cart-shipment-header-order-summary">
              {t('cart.marketplace.currency.value', {
                val: shipmentTotal,
                formatParams: {
                  val: { currency: checkoutState?.cart?.currency },
                },
              })}
            </P1>
          </div>
        </div>
      )}
    </FlatBox>
  );
};

export default CartShipmentHeader;
